"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports._iconImageStyle = exports._textStyle = exports._iconContainer = void 0;
const react_native_1 = require("react-native");
exports._iconContainer = (size, borderWidth, borderRadius, borderColor, checked, fillColor, unfillColor) => {
    return {
        width: size,
        height: size,
        borderWidth,
        borderColor,
        borderRadius,
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: checked ? fillColor : unfillColor,
    };
};
exports._textStyle = (checked, color, fontFamily, fontSize, textDecoration) => {
    return {
        fontSize,
        fontFamily,
        color,
        textDecorationLine: !textDecoration && checked ? "line-through" : "none",
    };
};
exports._iconImageStyle = (checkImageWidth, checkImageHeight, checked) => ({
    width: checkImageWidth,
    height: checkImageHeight,
    display: checked ? "flex" : "none",
});
exports.default = react_native_1.StyleSheet.create({
    container: {
        margin: 8,
        alignItems: "center",
        flexDirection: "row",
    },
    textContainer: {
        marginLeft: 16,
    },
});
//# sourceMappingURL=BouncyCheckbox.style.js.map